import { useEffect } from "react";

const useUserActivity = (onUserActive) => {
  useEffect(() => {
    const handleUserActivity = () => {
      onUserActive();
    };

    window.addEventListener("mousemove", handleUserActivity);
    window.addEventListener("keydown", handleUserActivity);

    return () => {
      window.removeEventListener("mousemove", handleUserActivity);
      window.removeEventListener("keydown", handleUserActivity);
    };
  }, [onUserActive]);
};

export default useUserActivity;
